var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":""},on:{"close":function($event){return _vm.$emit('dialog-close')}}},[_c('ContentHeader',{attrs:{"slot":"title","title":_vm.title},slot:"title"}),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }